import { Component, OnInit, Input } from "@angular/core";
import { LobbyService } from "src/app/services/lobby/lobby.service";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { GameHubControllerService } from "src/app/services/gameHub/game-hub-controller";
import { GamesService } from "src/app/services/lobby/games.service";
import { EventsService } from "src/app/services/event/event.service";
import { Platform } from "@ionic/angular";

@Component({
  selector: "app-games",
  templateUrl: "./games.component.html",
  styleUrls: ["./games.component.scss"],
})
export class GamesComponent implements OnInit {
  public closeClicked: boolean = false;
  public favGames: any[];
  public recentGames: any[];
  public imagesPath;
  public showtoggle:boolean = true;
  private games: any = "favorite";
  public isMobile: boolean = false;
  constructor(
    public lobbyService: LobbyService,
    public userSession: UserSessionService,
    public gameController: GameHubControllerService,
    private gamesService: GamesService,
    private events: EventsService,
    private platform:Platform
  ) {}

  async ngOnInit() {
    if (this.platform.is('capacitor')) {
      this.isMobile = true;
    }
    this.imagesPath = this.lobbyService.galleryImagePath;
    this.checkGames();
    this.changeToggleDefault();
    this.listenRecentFavGames();
  }

  ngOnDestroy() {
    this.events.destroy("event:checkRecent:Fav:games")
  }

  onChange(selected) {
    this.games = selected;
  }

  onCloseClicked(gamedata) {
    this.closeClicked = true;
  }

  launchCasinoGame(gameData) {
    if (this.closeClicked) {
      this.closeClicked = false;
      return;
    }

    this.closeGame();
    return this.gameController.launchCasinoGame(gameData);
  }

  closeGame() {
    return this.gameController.killAllInstances();
  }

  checkGames() {
    const recentGames = this.gamesService.recentGames;
    const favouriteGames = this.gamesService.favouriteGames;
    this.showtoggle = ((recentGames && recentGames.length > 0) || (favouriteGames && favouriteGames.length > 0));
  }

  // to change the toggle default
  changeToggleDefault() {
    if (this.isMobile) {
      this.games = 'recent';
    }
  }

  listenRecentFavGames(){
   this.events.subscribe("event:checkRecent:Fav:games", () => {
    this.checkGames();
   });
  }
}
